module.exports = __webpack_public_path__ + "static/media/arrow-down-orange.93a696b7.svg";